import { useState, useEffect } from 'react';

/**
 * A profile photo that degrades to the user's initial.
 *
 * The photo arrives as a short-lived signed URL, so `url` changes on every
 * profile load; a URL that has expired (or a photo removed in another tab)
 * must read as "no photo yet", never as a broken image. Fills its parent —
 * size and shape belong to whoever places it.
 */
export function ProfileAvatar({ url, fallback }) {
  const [broken, setBroken] = useState(false);

  // A new URL deserves a fresh attempt; otherwise one expired link would keep
  // the initial showing for the rest of the session.
  useEffect(() => { setBroken(false); }, [url]);

  if (!url || broken) return fallback;

  return (
    <img
      src={url}
      alt=""
      loading="lazy"
      decoding="async"
      onError={() => setBroken(true)}
      className="h-full w-full rounded-full object-cover"
    />
  );
}
